import Events from 'tf-events-1';

const eventsBySeId = {}

const initEvents = instance => {
	
	if(eventsBySeId[instance.id]){
		return eventsBySeId[instance.id];
	}

	const events = Events();
	eventsBySeId[instance.id] = events;

	return events;
}

export default initEvents;